import { Form, Modal, ButtonGroup, Button } from "react-bootstrap";
import { useApiMutation } from "../utils/api";
import { useForm } from "react-hook-form";
import { SubmitButton } from "./SubmitButton";
import { useState } from "react";

export const AddIdeaModal = ({
  board,
  close,
  refetch,
}: {
  board: any;
  close: () => void;
  refetch: () => void;
}) => {
  const { post, saving } = useApiMutation();
  const { register, handleSubmit } = useForm({
    defaultValues: {
      title: "",
      image: "",
      cost: "",
      link: "",
      multiple: "",
    },
  });
  const [activeView, setActiveView] = useState("quick");
  const [showAdvanced, setShowAdvanced] = useState(false);

  const onSubmit = async (data: any) => {
    if (data.multiple) {
      const titles: string[] = data.multiple.split("\n");
      for (const title of titles) {
        await post(`/api/user/create_idea/${board.id}`, { idea: { title } });
      }
      refetch();
      close();
    } else {
      post(`/api/user/create_idea/${board.id}`, { idea: data }).then(() => {
        refetch();
        close();
      });
    }
  };

  return (
    <Modal show={true} onHide={close}>
      <Modal.Header>
        <Modal.Title>Add Idea</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {showAdvanced && (
          <ButtonGroup className="w-100 mb-4 d-flex">
            {[
              ["quick", "Quick Add"],
              ["all", "All Fields"],
              ["multiple", "Multiple"],
            ].map(([view, label]) => (
              <button
                key={view}
                type="button"
                className={`flex-1 pv-2 border-0 ${
                  activeView === view ? "bg-light-gray" : "gray fw-300"
                }`}
                onClick={() => setActiveView(view)}
              >
                {label}
              </button>
            ))}
          </ButtonGroup>
        )}
        <Form onSubmit={handleSubmit(onSubmit)} id="add-idea-form">
          {activeView === "quick" && (
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                placeholder="Add idea or URL"
                autoFocus
                required
                disabled={saving}
                {...register("title", { required: true })}
              />
            </Form.Group>
          )}

          {activeView === "all" && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Title"
                  disabled={saving}
                  required
                  {...register("title", { required: true })}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Image URL</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Image URL"
                  disabled={saving}
                  {...register("image")}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Cost</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Cost"
                  disabled={saving}
                  {...register("cost")}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Link</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Link"
                  disabled={saving}
                  {...register("link")}
                />
              </Form.Group>
            </>
          )}

          {activeView === "multiple" && (
            <Form.Group className="mb-3">
              <Form.Control
                as="textarea"
                placeholder="Enter multiple ideas or URLs, one per line"
                rows={4}
                disabled={saving}
                {...register("multiple")}
              />
            </Form.Group>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-between w-100">
          <div>
            {!showAdvanced && (
              <div className="d-flex justify-content-end">
                <Button
                  variant="link"
                  size="sm"
                  onClick={() => setShowAdvanced(!showAdvanced)}
                >
                  {showAdvanced ? "Simple" : "Advanced"}
                </Button>
              </div>
            )}
          </div>
          <SubmitButton
            className="btn btn-primary"
            type="submit"
            form="add-idea-form"
            loading={saving}
          >
            Add
          </SubmitButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
